<template>
    <ContainerWithMenu>
        <div class="page-content">
            <div class="row margin-bottom-20">
                <div class="col-xs-7 col-md-7">
                    <ol class="breadcrumb">
                        <li><router-link :to="{name:'calendar'}">Home</router-link></li>
                        <li><router-link :to="{name:'content'}">{{$t('views.content.title')}}</router-link></li>
                        <li class="active">{{$t('views.videos.title')}}</li>
                    </ol>
                </div>
                <div class="col-xs-5 col-md-5 text-right">
                    <button class="btn btn-default" @click="$router.push({name:'content'})">
                        <i class="las la-undo"></i>
                        <span class="button-text">{{$t('navigation.back_to_content')}}</span>
                    </button>
                </div>
            </div>
            <hr>
            <div class="row margin-bottom-20">
                <div class="col-xs-12 col-md-7">
                    <h1 class="h2 margin-0">{{$t('views.videos.title')}}</h1>
                </div>
                <div class="col-xs-12 col-md-5 text-right">
                    <button
                            class="btn btn-primary btn-action-mobile"
                            @click="showAddVideoModal"
                    >
                        <i class="las la-plus"></i>
                        <span class="button-text">{{ $t('views.videos.new_video') }}</span>
                    </button>
                </div>
            </div>
            <Pagination
                    v-show="numberPagesVideos > 1"
                    :page-count="numberPagesVideos"
                    :click-handler="paginateCallback" />
            <VideoTable v-if="videos.length > 0" :videos="videos"></VideoTable>
            <div v-else>
                <span class="text-muted">{{ $t('views.videos.not_found') }}</span>
            </div>

        </div>
        <AddVideoModal v-show="addVideoModalVisible" :visible="addVideoModalVisible" @close-video-modal="addVideoModalVisible=false"></AddVideoModal>

        <SpinnerLoader v-show="loading"></SpinnerLoader>
    </ContainerWithMenu>
</template>

<script>
    import ContainerWithMenu from "../components/container/ContainerWithMenu";
    import SpinnerLoader from "../components/common/SpinnerLoader";
    import {LIMIT_RECORDS_API} from "../common/constants";
    import Pagination from "../components/common/Pagination";
    import VideoTable from "../components/video/VideoTable";
    import {getVideos} from "../api";
    import i18n from "../i18n";
    import {Utils} from "../common/utils";
    import AddVideoModal from "../components/modal/AddVideoModal";

    export default {
        title: i18n.t('views.videos.title'),
        name: "Videos",
        components: { ContainerWithMenu, Pagination, VideoTable, SpinnerLoader, AddVideoModal },
        data: () => {
            return {
                videos: [],
                countVideos: 0,
                limitVideos: LIMIT_RECORDS_API,
                currentPageVideo: 1,
                loading: false,
                addVideoModalVisible: false
            }
        },
        methods: {
            async getVideos(page = 1) {
                this.loading = true;
                try {
                    let videosResponse = await getVideos(page);
                    this.countVideos = videosResponse.count;
                    this.videos = videosResponse.results;

                    this.loading = false;
                } catch (e) {
                    this.loading = false;
                    console.log(e)
                }
            },
            showAddVideoModal() {
                this.addVideoModalVisible = true;
            },
            paginateCallback(pageNum) {
                this.getVideos(pageNum)
            }
        },
        computed: {
            numberPagesVideos: function () {
                return Utils.getNumberPageByCountLimit(this.countVideos, this.limitVideos);
            }
        },
        mounted() {
            this.getVideos()
        }

    };
</script>